import FItem from '.';

export default class FItemObject extends FItem {
  set(value = null) {
    super.set(value);
  }

  toString() {
    return this.value?.label || '';
  }
}
